module.exports = __webpack_public_path__ + "static/media/vertical-line.5cf8f54e.svg";